<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل نوع عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/typeview">انواع العقارات</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل نوع عقار</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="isLoading" class="text-center">
          <mainLoader />
        </div>
        <div v-else class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-pencil-square me-2 text-brown"></i> تعديل نوع عقار
            </h5>
            <div class="card shadow mb-4">
              <div class="text-center pt-3">
                <errorAlert v-if="hasError" :alertMessage= "message" />
              </div>
              <div v-if="success" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <form action="" @submit.prevent="typeUpdate">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>التصنيف:</label>
                        <select v-model="category" class="form-control">
                          <option value="residential">سكني</option>
                          <option value="commercial">تجاري</option>
                          <option value="agricultural">زراعي</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>الاسم - عربي:</label>
                        <input type="text" class="form-control" v-model="name" placeholder="الاسم" />
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>الاسم - إنجليزي:</label>
                        <input type="text" class="form-control" v-model="nameEn" placeholder="الاسم" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label>الصورة :</label>
                        <input type="file" class="form-control" @change.prevent="onFileLoad($event.target.files)" />
                      </div>
                    </div>
                    <div class="col">
                      <img :src="MEDIA_URL+this.image" class="img-fluid" alt="">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <div class="form-group py-2">
                        <label for="">الحاله :</label>
                        <select class="form-control" v-model="status">
                          <option :value="true">نشط</option>
                          <option :value="false">غير نشط</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="buildNumber" id="buildNumberField">
                        <label class="form-check-label" for="buildNumberField">
                          رقم المبنى
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="floorsCount" id="floorsCountField">
                        <label class="form-check-label" for="floorsCountField">
                          عدد الطوابق
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="floorNumber" id="floorNumberField">
                        <label class="form-check-label" for="floorNumberField">
                          رقم الطابق
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="apartmentNumber" id="apartmentNumberField">
                        <label class="form-check-label" for="apartmentNumberField">
                          رقم الشقة
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="roomsCount" id="roomsCountField">
                        <label class="form-check-label" for="roomsCountField">
                          عدد الغرف
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="bathrooms" id="bathroomsField">
                        <label class="form-check-label" for="bathroomsField">
                          عدد الحمامات
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="halls" id="hallsField">
                        <label class="form-check-label" for="hallsField">
                          عدد الصالات
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="age" id="ageField">
                        <label class="form-check-label" for="ageField">
                          عمر العقار
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="propertyType" id="propertyTypeField">
                        <label class="form-check-label" for="propertyTypeField">
                          نوع الساكن - عزاب ، عوائل
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="saudiBuildingCode" id="saudiBuildingCodeField">
                        <label class="form-check-label" for="saudiBuildingCodeField">
                          مطابق لكود البناء السعودي
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="furnished" id="furnishedField">
                        <label class="form-check-label" for="furnishedField">
                          مؤثث (نعم او لا)
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="plotNumber" id="plotNumberField">
                        <label class="form-check-label" for="plotNumberField">
                          رقم قطعة الارض
                        </label>
                      </div>
                    </div>
                    <div class="col-6 col-sm-3 pb-2">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="propertyFields" value="meterPrice" id="meterPriceField">
                        <label class="form-check-label" for="meterPriceField">
                          سعر المتر
                        </label>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col my-3">
                      <hr />
                    </div>
                  </div>
  
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>الاسم بالهيئة العامة للعقار - عربي:</label>
                        <input type="text" class="form-control" v-model="ragaNameAr" placeholder="الاسم" />
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group py-2">
                        <label>الاسم بالهيئة العامة للعقار - إنجليزي:</label>
                        <input type="text" class="form-control english-input" v-model="ragaNameEn" placeholder="الاسم" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer text-center">
                  <loader  v-if="loading" />
                  <button v-else type="submit" class="btn btn-success">
                    إرسال
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "typeupdate",
  data(){
    return {
      typeID: this.$route.params.key,
      loading: false,
      hasError: false,
      success: false,
      message: "",
      name: "",
      nameEn: "",
      ragaNameAr: "",
      ragaNameEn: "",
      status: true,
      image: "",
      isLoading: false,
      propertyFields: [],
      category: 'residential',
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods:{
    getData() {
      this.hasError = false;
      this.isLoading = true;
      this.$http.get(`/api/admin/propertyTypes/retrieve/${this.typeID}`).then(res => {
        // console.log(res);
        this.isLoading = false;
        this.name = res.data.propertyType.name;
        this.nameEn = res.data.propertyType.nameEn;
        this.ragaNameAr = res.data.propertyType.ragaNameAr;
        this.ragaNameEn = res.data.propertyType.ragaNameEn;
        this.category = res.data.propertyType.category;
        this.image = res.data.propertyType.icon;
        this.status = res.data.propertyType.isActive;
        this.propertyFields = res.data.propertyType.propertyFields;
      }).catch (err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    typeUpdate() {
      this.hasError = false;
      this.loading = true;
      const formData = new FormData();
      formData.append('name',this.name);
      formData.append('nameEn',this.nameEn);
      formData.append('ragaNameAr',this.ragaNameAr);
      formData.append('ragaNameEn',this.ragaNameEn);
      formData.append('icon',this.image);
      formData.append('isActive',this.status);
      formData.append('propertyFields', JSON.stringify(this.propertyFields));
      formData.append('category', this.category);
      this.$http.put(`/api/admin/propertyTypes/update/${this.typeID}`,formData).then(res => {
        this.loading = false;
        this.message = 'تم التعديل بنجاح';
        this.success = true;
        // setTimeout(()=> {
        // },15000)
        // this.$router.push({ path: '/typeupdate/'+this.typeID});
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.loading = false;
        window.scroll(0,0);
      })
    },
    onFileLoad(files) {
      this.image = files[0];
    }
  },
  created() {
    this.getData();
  }
};
</script>
